// extracted by mini-css-extract-plugin
export default {"container":"maincontent_container__k33x7"};